// 发布npm 需要切换到这个
export { pluginManager, revoke, nodeSchema, lazyLoadTick } from "k-form-design";

// 本地测试
// export { pluginManager } from "./PluginManager";
// export { revoke } from "./Revoke";
// export { nodeSchema } from "./NodeSchema";
// export { lazyLoadTick } from "./LazyLoadTick";
